import LoadingDots from "../../components/Loading/LoadingDots";
import erody from "../../assets/erody.svg";
import useLoadingDelay from "../../features/Loading/hooks/useLoadingDelay";
// import useSelectBrand from "../../hooks/styles/useSelectBrand";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import { useEffect, useState } from "react";
import useReactGASend from "../../hooks/useReactGASend";
import usePeerIp from "../../hooks/usePeerIp";

const ListItem = ({ children }) => {
  return (
    <li
      className="relative px-2.5 bg-white text-brand-gray text-lg font-semibold rounded-[2.5rem] z-10"
      style={{ paddingTop: "100%" }}
    >
      <span className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
        {children}
      </span>
    </li>
  );
};

const LoadingPage = () => {
  useLoadingDelay();
  const { text, hex } = useSelectBrand();
  const { makeEventTrackFn } = useReactGASend();
  const { getPeerIp } = usePeerIp();

  useEffect(() => {
    getPeerIp();
    makeEventTrackFn({ category: "event", action: "로딩페이지 인입" });
  }, []);

  return (
    <section
      className="flex flex-col items-center justify-center w-full h-screen p-6 text-center gap-y-20"
      style={{ backgroundColor: hex }}
    >
      <div className="flex flex-col items-center">
        <div className="mb-7">
          <img src={erody} alt="이로디캐릭터" />
        </div>
        <div className="mb-7 font-semibold leading-[26px] ">
          <p className="text-2xl">{text}</p>
          <p className="text-xl">
            디지털 상담으로 연결 중입니다. <br /> 잠시만 기다려 주세요.
          </p>
        </div>
        <LoadingDots />
      </div>
      <div className="w-full">
        <ul className="relative grid grid-cols-3 gap-1.5 mb-8 after:content-[''] after:absolute after:w-full after:h-[1px] after:top-1/2 after:left-0 after:bg-black">
          <ListItem>
            대기 하지
            <br /> 않고
          </ListItem>
          <ListItem>
            눈으로
            <br /> 보면서
          </ListItem>
          <ListItem>
            간편하게
            <br />
            처리
          </ListItem>
        </ul>
        <p className="text-[15px] text-gray-600 font-semibold ">
          이용 중 데이터 요금이 부과 될 수 있습니다. <br />
          연결 후 화면에서 선택해주세요.
        </p>
      </div>
    </section>
  );
};

export default LoadingPage;
